<template>
  <v-main v-if="!consentLoader">
    <div class="title-background">
      <TitleHeader
        :title="$t('form.subtitle')"
        :subtitle="$t('form.title')"
      />
    </div>
    <v-container class="py-0 mb-12">
      <v-row
        no-gutters
        class="mt-3"
      >
        <v-col cols="12">
          <ReturnLink
            :label="$t('form.returnToFamilyDetails')"
            to-name="family"
            :params="{ familyEditionId: familyEditionId, warehouseId: warehouseId }"
          />
        </v-col>
        <v-col
          cols="12"
          class="mt-3 sz-primary-background px-5 py-3 sz-primary-grey--text f-18"
        >
          <p class="mb-0 font-weight-medium">
            <span class="f-14 sz-secondary-grey--text font-weight-regular">
              {{ $t('label.chosen') }}:
            </span>
            <span class="d-block d-md-inline-block">{{ familyTitle }}</span>
            <span class="font-weight-regular">
              ({{ $t('label.warehouse') }}: {{ familyWarehouse?.name }})
            </span>
          </p>
        </v-col>
        <v-col
          cols="12"
          class="mt-5"
        >
          <h2 class="f-24 sz-primary-grey--text font-weight-medium">
            {{ $t('form.contactDetails') }}
          </h2>
          <p
            v-orphans
            class="f-16 sz-secondary-grey--text"
          >
            {{ $t('form.contactDetailsInfo') }}
          </p>
          <v-row
            no-gutters
            class="flex-nowrap my-4"
          >
            <InfoBox
              :title="$t('form.validDetails.1')"
              :text="$t('form.validDetails.2')"
              inline
            />
          </v-row>
        </v-col>
        <p class="prepend-required f-14 sz-secondary-grey--text mb-0">
          {{ $t('label.fieldsRequired') }}
        </p>
        <v-col
          cols="12"
          class="mt-3"
        >
          <PersonalDataForm
            :captcha-required="captchaRequired"
            :warehouse-id="familyWarehouse?.id"
          />
        </v-col>
        <v-col
          cols="12"
          class="mt-5 mb-0"
        >
          <ReturnLink
            :label="$t('form.returnToFamilyDetails')"
            to-name="family"
            :params="{ familyEditionId: familyEditionId, warehouseId: warehouseId }"
          />
        </v-col>
      </v-row>
    </v-container>
    <FooterComponent />
  </v-main>
</template>

<script>
import PersonalDataForm from '@/components/FamilyChoiceForm/PersonalDataForm';
import FooterComponent from '@/components/widgets/FooterComponent';
import InfoBox from '@/components/widgets/InfoBox.vue';
import ReturnLink from '@/components/widgets/ReturnLink';
import TitleHeader from '@/components/widgets/TitleHeader';
import { useConsentStore } from '@/stores/Consent';
import { useFamilyChoiceStore } from '@/stores/FamilyChoice';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import ROUTE_NAMES from '@/constants/routeNames';
export default {
    name: 'FamilyChoiceForm',
    components: { FooterComponent, PersonalDataForm, ReturnLink, TitleHeader, InfoBox },
    beforeRouteEnter (to, from) {
        const familyChoiceStore = useFamilyChoiceStore();

        if (!from?.name || !familyChoiceStore.familyTitle) {
            return {
                name: ROUTE_NAMES.FAMILY,
                params: {
                    familyEditionId: to.params.familyEditionId,
                    warehouseId: to.params.warehouseId
                }
            };
        }
    },
    setup () {
        const familyChoiceStore = useFamilyChoiceStore();
        const { familyEditionId, warehouseId, familyTitle, familyWarehouse, captchaRequired } = storeToRefs(familyChoiceStore);

        const consentStore = useConsentStore();
        consentStore.init();

        const consentLoader = computed(() => consentStore.loader);

        return {
            familyEditionId,
            warehouseId,
            familyTitle,
            familyWarehouse,
            captchaRequired,
            consentLoader
        };
    }
};
</script>

<style scoped></style>
